const Card = {
  defaultProps: {},
  styleOverrides: {
    root: () => ({
      display: "flex",
      flexDirection: "column",
    }),
  },
};

export default Card;
